// CJS interop shims for Rolldown (Vite 8).
// Rolldown doesn't resolve __esModule default exports from CJS packages,
// so `import X from "cjs-pkg"` yields the module object instead of the default export.
// This file re-exports affected packages with correct interop.

/* oxlint-disable typescript/no-explicit-any */
const interop = <T>(mod: T): T => (mod as any).default ?? mod;

// react-use-websocket
import _useWebSocket from "react-use-websocket";
export const useWebSocket = interop(_useWebSocket);
export { ReadyState } from "react-use-websocket";
export type { Options as WebSocketOptions, SendMessage } from "react-use-websocket";

// react-paginate
import _ReactPaginate from "react-paginate";
export const ReactPaginate = interop(_ReactPaginate);

// react-datepicker
import _DatePicker from "react-datepicker";
export const DatePicker = interop(_DatePicker);

// axios-retry
import _axiosRetry from "axios-retry";
export const axiosRetry = interop(_axiosRetry);
